import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useDebounce } from 'react-use'
import styled from 'styled-components'
import { useCprmSearch, FilteringWithDraft, filteringWithDraftLabelMap } from '../../pages/Search/hooks'
// eslint-disable-next-line import/no-cycle
import { AllAxesMultipleSelectTags } from '../AllAxesMultipleSelectTags'

export const ConditionTitle: React.FC<{ style?: React.CSSProperties }> = ({ children, style }) => (
  <Typography variant="subtitle2" style={{ minWidth: '150px', display: 'inline-block', ...style }}>
    {children}
  </Typography>
)

export const ConditionBox = styled(Box)`
  margin: 10px 0;
`

// eslint-disable-next-line max-lines-per-function
const Component = () => {
  const {
    filteringWithDraft,
    freewords,
    filterTagsV2,
    excludeTagsV2,
    handleFilteringWithDraft,
    handleFreewords,
    handleFilterTagsV2,
    handleExcludeTagsV2,
    handleReset,
    verticalAxis,
    horizontalAxis,
    hideUnspecifiedTags
  } = useCprmSearch()

  const [_freewords, setFreewords] = React.useState<string>(freewords)
  React.useEffect(() => {
    setFreewords(freewords)
  }, [freewords])
  useDebounce(
    () => {
      handleFreewords(_freewords)
    },
    1000,
    [_freewords]
  )

  const SearchOptions = React.useMemo(
    () => (
      <>
        <Typography variant="h2">Filter</Typography>
        <Typography variant="body2" gutterBottom>
          {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
          {
            'Filter papers by keywords and/or tags. Example: If you’re interested in depression, filter papers with the corresponding DSM 5 tag and visualize them with different axes.'
          }
        </Typography>
        <ConditionBox>
          <ConditionTitle style={{ paddingTop: '10px' }}>Filter by free words :</ConditionTitle>
          <TextField
            variant="outlined"
            size="small"
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            style={{ maxWidth: '1000px' }}
            margin="none"
            placeholder="i.e. Title, Authors, Abstract..."
            name="_freewords"
            value={_freewords}
            onChange={e => {
              setFreewords(e.target.value)
            }}
            type="search"
          />
        </ConditionBox>
        <AllAxesMultipleSelectTags
          title="Filter by tags"
          selectTags={filterTagsV2}
          handleSelectTags={handleFilterTagsV2}
        />
        <AllAxesMultipleSelectTags
          title="Exclude by tags"
          selectTags={excludeTagsV2}
          handleSelectTags={handleExcludeTagsV2}
          verticalAxis={verticalAxis}
          horizontalAxis={horizontalAxis}
          hideUnspecifiedTags={hideUnspecifiedTags}
        />
        <ConditionBox>
          <ConditionTitle style={{ paddingTop: '10px' }}>Filter by registration process :</ConditionTitle>
          <RadioGroup
            row
            value={filteringWithDraft}
            onChange={e => handleFilteringWithDraft(e.target.value as FilteringWithDraft)}
          >
            <FormControlLabel
              value={FilteringWithDraft.ALL}
              control={<Radio />}
              label={filteringWithDraftLabelMap.ALL}
            />
            <FormControlLabel
              value={FilteringWithDraft.ONLY_REGISTRATION}
              control={<Radio />}
              label={filteringWithDraftLabelMap.ONLY_REGISTRATION}
            />
            <FormControlLabel
              value={FilteringWithDraft.ONLY_DRAFT}
              control={<Radio />}
              label={filteringWithDraftLabelMap.ONLY_DRAFT}
            />
          </RadioGroup>
        </ConditionBox>
        <Box style={{ margin: '10px 0' }}>
          <Button variant="outlined" color="default" size="small" onClick={handleReset}>
            Reset All
          </Button>
        </Box>
      </>
    ),
    [
      _freewords,
      filterTagsV2,
      handleFilterTagsV2,
      excludeTagsV2,
      handleExcludeTagsV2,
      verticalAxis,
      horizontalAxis,
      hideUnspecifiedTags,
      filteringWithDraft,
      handleReset,
      handleFilteringWithDraft
    ]
  )

  return SearchOptions
}

export default Component
